import styled from 'styled-components'

type WarningIconProps = {
  $size: number
}

export const WarningSectionContainer = styled.section`
  width: 100%;
  background-color: var(--gray100);
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
`

export const WarningIconContainer = styled.section<WarningIconProps>`
  min-width: ${({ $size }) => `${$size}px`};
  min-height: ${({ $size }) => `${$size}px`};
`
